/**
 * Product gallery — primary image + 5-thumb strip + sale sticker overlay.
 */
import { Leaf } from "lucide-react";

export default function ProductGallery({
    images,
    product,
    imgIdx,
    setImgIdx,
    inStock,
    sticker,
}) {
    return (
        <div>
            <div className="relative aspect-square bg-zen-surface border border-zen-ink/10 overflow-hidden">
                {images[imgIdx]?.url ? (
                    <img
                        src={images[imgIdx].url}
                        alt={product.name}
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-zen-muted">
                        <Leaf size={48} />
                    </div>
                )}
                {inStock && sticker && (
                    <div
                        data-testid={`product-sticker-${product.slug}`}
                        data-sticker-kind={sticker.kind}
                        className="absolute top-5 right-5 bg-red-600 text-white font-serif font-medium px-3.5 py-2 shadow-[0_4px_14px_rgba(0,0,0,0.22)] -rotate-3 select-none"
                        title={sticker.label}
                    >
                        <span className="block text-base sm:text-lg leading-none tracking-tight">
                            {sticker.label}
                        </span>
                    </div>
                )}
            </div>
            {images.length > 1 && (
                <div className="mt-3 grid grid-cols-5 gap-2">
                    {images.slice(0, 5).map((im, i) => (
                        <button
                            key={i}
                            onClick={() => setImgIdx(i)}
                            data-testid={`product-thumb-${i}`}
                            className={`aspect-square border overflow-hidden ${
                                i === imgIdx
                                    ? "border-zen-olive"
                                    : "border-zen-ink/10 hover:border-zen-ink/30"
                            }`}
                        >
                            <img
                                src={im.url}
                                alt=""
                                className="w-full h-full object-cover"
                            />
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
